import { Typography } from "@material-ui/core"
import SingleButtonSelection from "common/bit/SingleButtonSelection"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import { TypographyRtl } from "theme/shared"

const StyledWrapper = styled.div`
  width: 100%;
`
const StyledTitle = styled(Typography).attrs({ variant: "h2" })`
  margin-bottom: 10px;
  color: #101010;
  font-size: 20px;
  font-weight: 300;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 50px;
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: center;
  }
`
const StyledButton = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`
const StyleCardButton = styled.div<{ $activeButton: boolean }>`
  display: flex;
  width: max-content;
  align-items: start;
  flex-direction: column;
  p {
    color: ${(p) => (p.$activeButton ? p.theme.colors.black : "#616161")};
  }
`
const StyleLine = styled.div<{ $activeButton: boolean }>`
  background-color: ${(p) =>
    p.$activeButton ? p.theme.colors.black : "transparent"};
  border-radius: 100px;
  width: 100%;
  height: 4px;
`
type AreSelectionButtonsProps = {
  activeButton: number
  setActiveButton: Dispatch<SetStateAction<number>>
  className?: string
  onSelectFunction?: () => void
}

const AreSelectionButtons = ({
  activeButton,
  setActiveButton,
  className,
  onSelectFunction,
}: AreSelectionButtonsProps) => {
  return (
    <StyledWrapper className={className}>
      <StyledTitle tabIndex={0}>{`בחירת אזור`}</StyledTitle>
      <StyledSingleButtonSelection
        id={"era-selection"}
        items={["הכל", "צפון", "מרכז", "דרום"].map((item, index) => ({
          value: index,
          name: item,
        }))}
        itemsPerRow={"auto"}
        selectedValue={activeButton}
        onSelect={(code) => {
          setActiveButton(Number(code))
          onSelectFunction ? onSelectFunction() : null
        }}
        customButton={(radioId, isSelected, item) => (
          <StyledButton htmlFor={radioId} $activeButton={isSelected}>
            <StyleCardButton $activeButton={isSelected}>
              <TypographyRtl variant="body2">{item.name}</TypographyRtl>
              <StyleLine $activeButton={isSelected} />
            </StyleCardButton>
          </StyledButton>
        )}
      />
    </StyledWrapper>
  )
}

export default AreSelectionButtons
